export default __webpack_public_path__ + "static/media/scarring.4653eefe.svg";